module.exports = __webpack_public_path__ + "media/images/check_mark-9c64a365.svg";